import { pxToRem } from "styled-media-query";
import { getDeviceConfig } from "Hooks/useBreakpoint";

const breakpoints = pxToRem({
  mobile: "768px",
  ipad: "1024px",
  ipadPro: "1025px",
  desktop: "1250px",
  large: "1920px",
});

export const currentBreakpoint = () => {
  return getDeviceConfig(window.innerWidth);
};
export default breakpoints;
